<template>
    <div id="app">
        <router-view/>
    </div>
</template>
<script>
import store from '@/store'
import { deviceEnquire } from '@/utils/device'
export default {
    created () {
        deviceEnquire(device => {
            if (device === 'tablet') {
                store.commit('setDeviceType', { device, sidebar: false })
            } else {
                store.commit('setDeviceType', { device, sidebar: true })
            }
        })
    }
}
</script>

<style lang="less">
    #app {
        height: 100%;
    }
</style>
